<!-- src/app/pages/dashboard/components/analysis/analysis.component.html -->
<div class="grid sm:grid-cols-2 gap-4 xs:grid-cols-1">
    <!-- Cascade of Care with Selected Simulation and Active Interventions -->
    <div class="analysisComponent">
        <div class="rounded-2xl border border-surface-200 bg-surface-0 p-4">
            <div class="flex items-baseline justify-between mb-2">
                <h5>Cascade of Care</h5>
                <div class="text-xs text-slate-600">
                    <!-- Selected Simulation: <span class="font-semibold">{{ selectedSimulation$ | async }}</span> -->
                </div>
            </div>
            <p>
                Base (BAU): {{ displayRange$ | async }} | Active Interventions: <span class="font-semibold">{{ activeInterventionsCount$ | async }}</span>
            </p>
            @if (cascade$ | async; as c) {
                <p-chart [type]="'bar'" [data]="c.data" [options]="c.options"></p-chart>
            }
        </div>
    </div>

    <!-- Scenarios (multi-line) -->
    <div class="analysisComponent">
        <div class="rounded-2xl border border-surface-200 bg-surface-0 p-4">
            <div class="flex justify-between headBlock">
                <h5>Scenarios</h5>
                <div class="analysisDropdown">
                    <p-select [options]="metricOptions" [(ngModel)]="metric" optionLabel="label" optionValue="value" placeholder="Metric"> </p-select>
                    <p-select [options]="groupOptions" [(ngModel)]="group" optionLabel="label" optionValue="value" placeholder="Group"> </p-select>
                </div>
            </div>
            @if (chart$ | async; as chart) {
                <p-chart type="line" [data]="chart.data" [options]="chart.options" style="height: 500px; width: 100%"></p-chart>
            }
        </div>
    </div>

    <!-- Reserved for future analysis blocks -->
    <div class="analysisComponent"></div>
</div>
